import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { ModalComponent } from '@scalefast/components/modal';
import { ContentfulBiography } from '../../../../core/interfaces/Contentful/Biography/ContentfulBiography';
import { SanitizeContentfulHTMLPipe } from '../../../pipes/sanitize-contentful-html.pipe';
import { ContentfulProductOverviewContent } from 'src/app/core/interfaces/Contentful/ProductOverview/ContentfulProductOverviewContent';
import { ContentfulFAQContent } from 'src/app/core/interfaces/Contentful/FAQ/ContentfulFAQContent';
import { ContentfulArticleContent } from 'src/app/core/interfaces/Contentful/Article/ContentfulArticleContent';
import { ContentfulCategoryContent } from 'src/app/core/interfaces/Contentful/Category/ContentfulCategoryContent';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';
import { ContentfulPageContent } from 'src/app/core/interfaces/Contentful/Page/ContentfulPageContent';

@Component({
  selector: 'app-contentful-biography',
  templateUrl: './contentful-biography.component.html',
  styleUrls: ['./contentful-biography.component.scss'],
  standalone: true,
  imports: [ModalComponent, SanitizeContentfulHTMLPipe],
})
export class AppContentfulBiographyComponent implements OnChanges {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;
  @ViewChild(ModalComponent) modalComponent: ModalComponent = new ModalComponent();
  biography: ContentfulBiography | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes.contentfulSectionContent.currentValue;
    if (currentValue && currentValue.contentfulContent?.content) {
      if (this.hasBiography(currentValue.contentfulContent.content)) {
        this.biography = currentValue.contentfulContent.content.biography;
      }
    }
  }

  closeContactModal() {
    this.modalComponent.close();
  }

  openModal() {
    this.modalComponent.show();
  }

  hasBiography(
    object:
      | ContentfulPageContent
      | ContentfulArticleContent
      | ContentfulProductOverviewContent
      | ContentfulCategoryContent
      | ContentfulFAQContent,
  ): object is ContentfulArticleContent {
    return 'biography' in object;
  }
}
